<template>
    <v-main>
        <div id="section-to-print">
        <v-flex xs12 md6 v-model="showPrint">
          <v-textarea
            name="input-7-1"
            value="printTitle"
            v-model="printTitle"
            hint="">
          </v-textarea>
        </v-flex>
       <div v-if="selectedRegistration === null" class="mt-4" style="text-align: center">{{$t("No recent registrations found")}}</div>
       <div v-else>
        <v-flex xs12 md6 class="ml-4">
        <v-card flat class="mb-6" v-if="(selectedRegistration.Registration != null)">
          <v-layout row wrap>
            <v-flex>
              <v-layout v-if="!isHide('Vehicle')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4 class="font-weight-bold">{{$t("Vehicle")}}:</v-flex>
                <v-flex d-flex xs8 class="font-weight-bold" >{{selectedRegistration.Registration.VehicleNo}} - {{selectedRegistration.Registration.VehicleLicensePlateNo}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Article')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Article")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.Registration.ArticleNo}} - {{selectedRegistration.Registration.ArticleName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Carrier')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Carrier")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.Registration.CarrierNo}} - {{selectedRegistration.Registration.CarrierName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Customer')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Customer")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{getCustomerStr(selectedRegistration)}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Agreement')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Agreement")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.Registration.AgreementNo}} - {{selectedRegistration.Registration.AgreementName}}</v-flex>
              </v-layout>
                 <v-layout v-if="!isHide('Delivery')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                 <v-flex d-flex xs4>{{$t("Delivery")}}:</v-flex>
              <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.Registration.DeliveryNo}} - {{selectedRegistration.Registration.DeliveryName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('RequisitionNo1')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("RequisitionNo1")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Registration.RequisitionNo1}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('RequisitionNo2')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("RequisitionNo2")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Registration.RequisitionNo2}}</v-flex>
              </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("ScanXRegNo")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Registration.ScanXRegNo}}</v-flex>
              </v-layout>
                <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                  <v-flex d-flex xs4>{{$t("1. weight")}}:</v-flex>
                  <v-flex d-flex xs8>{{getGrossWeightStr(selectedRegistration)}}</v-flex>
                </v-layout>
                <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                  <v-flex d-flex xs4>{{$t("2. weight")}}:</v-flex>
                  <v-flex d-flex xs8>{{get2WeightStr(selectedRegistration)}}</v-flex>
                </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("WeightNet")}}:</v-flex>
                <v-flex d-flex xs8>{{getNetWeightStr(selectedRegistration)}}</v-flex>
              </v-layout>
              <v-layout row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Date")}}:</v-flex>
                <v-flex d-flex xs8>{{getDate(selectedRegistration.Registration.DateFirst)}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Plant')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Plant")}}:</v-flex>
                <v-flex d-flex xs8 style="padding-right: 6px">{{selectedRegistration.Registration.PlantNo}} - {{selectedRegistration.Registration.PlantName}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Facility')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Facility")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Registration.Facility}}</v-flex>
              </v-layout>
              <v-layout v-if="!isHide('Comment')" row wrap class="textsize-svs" style="padding: 2px 2px 2px 14px">
                <v-flex d-flex xs4>{{$t("Comment")}}:</v-flex>
                <v-flex d-flex xs8>{{selectedRegistration.Registration.Comment1}}</v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
        <v-flex>
          <v-data-table id="table-to-print" hide-default-footer dense
            :headers="translatedHeaders()"
            :items="selectedRegistrations"
                    :items-per-page="1"
                    class="elevation-1">
                    <!-- <template v-slot:body="{ items }">
                      <tbody>
                          <tr v-for="header in headers">
                          <td>
                              {{ header.text }}
                          </td>
                          <td v-for="item in items">
                              {{ item[header.value] }}
                          </td>
                      </tr>
                      </tbody>
                    </template> -->
                    <template v-slot:[`item.DateFirst`]="{ item }">
                        <v-flex class="font-weight-bold">
                          {{ getDate(item.DateFirst) }}
                        </v-flex>
                      </template>
                  </v-data-table>
        </v-flex>
      </v-flex>
          <!-- <v-btn class="mr-1 mb-1" @click="close()" color="primary">
                      {{$t("Close")}}
                    </v-btn>
          <v-btn class="mr-1 mb-1" @click="printRegistration()" color="primary">
                      {{$t("Print")}}
                    </v-btn> -->
    </div>
  </div>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as ScanMobile from '@/modules/scan-mobile/scan-mobile'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as Security from '@/core/security'
import * as DateUtil from '@/core/date'
import * as Archive from '@/core/archive'
import _ from 'lodash' // clone

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'scan-mobile-registrationprint',
    loading: true,
    printTitle: '',
    selectedRegistration: null,
    selectedRegistrations: [],
    useFacilityDescription: false,
    facilityDisplay: '',
    facilitiesDisplay: [],
    redirectTo: 'scan-mobile-registrations',
    hiddenFields: [],
    showPrint: true,
    results: [],
    headers: [
      /* { text: 'VehicleNo', value: 'VehicleNo' }/* ,
      { text: 'ArticleNo', value: 'ArticleNo' },
      { text: 'CarrierNo', value: 'CarrierNo' },
      { text: 'CustomerNo', value: 'CustomerNo' },
      { text: 'AgreementNo', value: 'AgreementNo' },
      { text: 'DeliveryNo', value: 'DeliveryNo' },
      { text: 'RequisitionNo1', value: 'RequisitionNo1' },
      { text: 'RequisitionNo2', value: 'RequisitionNo2' },
      { text: 'ScanXRegNo', value: 'ScanXRegNo' },
      { text: 'WeightFirst', value: 'WeightFirst' },
      { text: 'WeightSecond', value: 'WeightSecond' },
      { text: 'WeightNet', value: 'WeightNet' },
      { text: 'DateFirst', value: 'DateFirst' },
      { text: 'PlantNo', value: 'PlantNo' },
      { text: 'Facility', value: 'Facility' },
      { text: 'Comment1', value: 'Comment1' } */
    ],
    id: null
  }),
  computed: {
  },
  methods: {
    printRegistrationBlock () {
      window.onafterprint = () => {
        this.close()
      }

      window.print()
    },
    printRegistration () {
      window.print()
    },
    close () {
      this.$router.push({ name: this.redirectTo })
    },
    printRegistrationBtn () {
      window.print()
      this.$router.push({ name: this.redirectTo })
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    translatedHeaders () {
      return this.headers.map(header => {
        const h = { ...header }
        h.text = this.$t(header.text)
        return h
      })
    },
    getCustomerStr (smReg) {
      if (smReg.Registration.CustomerNo && smReg.Registration.CustomerName) { return smReg.Registration.CustomerNo + ' - ' + smReg.Registration.CustomerName } else if (smReg.Registration.CustomerNo) { return smReg.Registration.CustomerNo } else if (smReg.Registration.CustomerName) { return smReg.Registration.CustomerName } else { return '' }
    },
    getGrossWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightFirst) + ' kg'
    },
    get2WeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightSecond) + ' kg'
    },
    getNetWeightStr (smReg) {
      // Weighing is via ScanMobile
      return (smReg.Registration.WeightNet) + ' kg'
    },
    getDate (date) {
      // return DateUtil.getSmartDate(date)
      return DateUtil.getDateTime(date)
    }
  },
  async mounted () {
    const regId = this.$route.params.id
    if (this.$route.params.header === undefined) {
      // Go back to Registrations
      this.$router.push({ name: this.redirectTo })
    }

    var noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }

    const facilitiesRes = await Archive.loadFacilities()
    const facilitiesResDescription = _.cloneDeep(facilitiesRes)
    if (!facilitiesRes.failed) {
      // Let user select no facilities (= show data from all allowed facilities)
      if (!facilitiesRes.data.includes('')) facilitiesRes.data.unshift({ No: '', Name: '' })
      this.facilities = facilitiesRes.data.map(item => {
        return {
          text: item.No,
          value: item.No,
          item: item
        }
      })
    }
    this.facilitiesDisplay = this.facilities
    if (this.useFacilityDescription) {
      // const facilitiesRes2 = await Archive.loadFacilities()
      var d = facilitiesResDescription.data
      if (!d.includes('')) d.unshift({ No: '', Description: '' })
      this.facilitiesDescription = d.map(item => {
        return {
          text: item.No,
          value: item.Description,
          item: item
        }
      })

      this.facilitiesDisplay = this.facilitiesDescription
    }

    if (this.useFacilityDescription) {
      var facilityDisplay = this.facilitiesDisplay.find(f => f.value === this.facilityDisplay)
      if (facilityDisplay != null) {
        this.facilityNo = facilityDisplay.item.No
      }
    } else {
      this.facilityNo = this.facilityDisplay
    }

    if (this.$route.params.header !== undefined) {
      this.printTitle = this.$route.params.header
    }

    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registration.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'ScanMobile_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
    }

    if (regId) {
      const res = await ScanMobile.loadRegistration(regId)
      if (!res.failed) {
        this.id = regId
        this.selectedRegistration = res.data
        this.selectedRegistrations[0] = this.selectedRegistration.Registration
        if (this.useFacilityDescription) {
          var f = this.facilitiesDisplay.find(f => f.text === this.selectedRegistrations[0].Facility)
          this.selectedRegistrations[0].Facility = f.value
        }
      }
    }
    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })
    this.$nextTick(() => {
      this.loading = false
      this.printRegistrationBlock()
    })
  }
}

</script>

  <style>
  @media print {
    .show-on-print {
      display: block !important;
    }
    body * {
      visibility: hidden;
    }
    #section-to-print, #section-to-print * {
      visibility: visible;
    }
    #section-to-print {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
    }
    #table-to-print {
      position: absolute;
      left: 0;
      top: auto;
    }
    .v-main {
      padding: 0 !important;
    }
    .v-data-table td {
      font: 16px;
    }
    tbody tr:nth-of-type(even) {
      background-color: rgba(0, 0, 0, .05);
    }
  }
  </style>
